export const getLogStatus = (): boolean | null => {
  const status = localStorage.getItem('showcaseLog');
  return status && JSON.parse(status);
};

export const setLogStatus = (status: boolean) => {
  localStorage.setItem('showcaseLog', `${status}`);
};
